import { LoggerConfig } from '@eng-dx-gpt/logger';

export const loggerConfig: LoggerConfig = {
    level: 0
};
